<template>
  <!-- BUY MODAL -->
  <div v-if="displayedEvent" class="modal-bg">
    <div class="modal-view">
      <nav class="navbar has-border-bottom is-fixed-top" role="section" >
        <div class="container">
          <div class="navbar-brand">
            <BackButton icon="mdi-close" size="mdi-24px" iconSize="is-medium"></BackButton>
          </div>
        </div>
      </nav>

      <div v-if="userBasket" style="margin-top: 68px">
        <div class>
          <p class="title mb-1 is-5 mx-1">{{ $t('ui.selectTicket') }}</p>
          
          <SelectDate
            v-if="displayedEvent"
            :event="displayedEvent"
            @on-select-date="setSelectedDateTime"
            class="mb-1"
          ></SelectDate>

          <!-- <hr /> -->

          <div class="mx-1 is-size-13px">
            <p class="has-text-weight-medium has-text-black-ter is-size-14px">
              <span class="icon has-text-grey-dark is-small mr-quarter">
                <i class="mdi mdi-ticket mdi-16px"></i>
              </span>
              {{ $t('ui.ticket')}}
            </p>

            <div class="select-ticket-wrapper mt-half" :class="{ 'pb-0': basketTotal.totalPrice < 1}">
              <!-- <p class="has-text-weight-medium mb-half is-size-7 has-text-grey-dark " >{{ $t('ui.selectTicket') }}</p> -->
              <!-- ticketTypes and Amounts -->
              <div
                class="columns is-mobile mb-0"
                v-for="(item, ind) in userBasket.tickets"
                :key="item.id"
              >
                <div class="column">
                  <p
                    class="title has-text-weight-medium is-size-13px mb-0"
                  >{{ $t(`ticket.${item.ticketType}`) }}</p>
                  <p>{{ item.ticketPrice }} ₺</p>
                </div>
                <div class="column py-1">
                  <div class="field has-addons is-pulled-right">
                    <div class="control">
                      <a
                        class="button is-small is-round-outlined"
                        :disabled="item.numberOfTickets === 0"
                        @click="decrementTicketNumber(ind)"
                      >
                        <span class="icon">
                          <i class="mdi mdi-minus"></i>
                        </span>
                      </a>
                    </div>

                    <div class="control">
                      <a
                        class="button is-small has-text-weight-medium is-white "
                        style="width: 24px; margin: 0 4px;"
                      >{{ item.numberOfTickets }}</a>
                    </div>
                    <div class="control">
                      <a class="button is-small is-round-outlined" @click="incrementTicketNumber(ind)">
                        <span class="icon">
                          <i class="mdi mdi-plus"></i>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <!-- selected  tickets table-->
              <div :class="{ 'mt-1': basketTotal.totalPrice > 3 }">
                <div v-for="item in userBasket.tickets" :key="item.id">
                  <div class="level is-mobile mb-0" v-if="item.numberOfTickets">
                    <div class="level-left">
                      <div class="level-item">
                        <span>
                          {{ item.ticketPrice }} ₺
                          <span class="has-text-weight-light">x</span>
                          {{ item.numberOfTickets }} {{ $t(`ticket.${item.ticketType}`) }}
                        </span>
                        <b-tooltip
                          v-if="item.ticketType === 'student'"
                          multilined
                          class="ml-half"
                          type="is-white"
                          :label="$t('ui.studentTicketTooltip')"
                        >
                          <b-tag
                            class="is-rounded is-small has-border is-white has-text-grey-dark"
                          >?</b-tag>
                        </b-tooltip>
                      </div>
                    </div>
                    <div class="level-right">
                      <div class="level-item">{{ item.numberOfTickets * item.ticketPrice }} ₺</div>
                    </div>
                  </div>
                  <!-- hr -->
                  <hr class="is-narrow" v-if="item.numberOfTickets >= 1 " />
                </div>
              </div>

              <!-- service fee -->
              <div class="level is-mobile mb-0" v-if="basketTotal.totalPrice > 3">
                <div class="level-left">
                  <div class="level-item">
                    <span class>{{ $t('ticket.serviceFee') }}</span>
                    <b-tooltip
                      multilined
                      class="ml-half "
                      type="is-white"
                      :label="$t('ui.serviceFeeExplanation')"
                    >
                      <b-tag
                        class="is-rounded is-small has-border is-white has-text-grey-dark"
                      >?</b-tag>
                    </b-tooltip>
                  </div>
                </div>
                <div class="level-right">
                  <div class="level-item">{{ basketTotal.serviceFee }} ₺</div>
                </div>
              </div>
              <hr class="is-narrow" v-if="basketTotal.totalPrice > 3" />

              <!-- total -->
              <div class="level is-mobile mb-0" v-if="basketTotal.totalPrice > 3">
                <div class="level-left">
                  <div class="level-item">
                    <span class="has-text-weight-bold">{{ $t('ui.total') }}</span>
                  </div>
                </div>
                <div class="level-right">
                  <div class="level-item has-text-weight-bold">{{ basketTotal.totalPrice }} ₺</div>
                </div>
              </div>
            </div>
            <div class="mt-2 mb-2">
              <button
                :class="{ 'is-loading': isBuyLoading }"
                class="button is-fullwidth has-text-weight-medium is-danger"
                @click="buyTickets"
              >{{ $t('ui.buyTicket') }}</button>
              <p
                class="is-size-7 mt-half has-text-weight-medium has-text-centered"
              >{{ $t('ticket.youWontBeChargedYet') }}</p>
            </div>
          </div>

          <!-- FloorPlan -->
        </div>
      </div>
    </div>
  </div>
  <!-- ./BUY MODAL -->
</template>

<script>
import { mapGetters } from "vuex";
import SelectDate from "@/components/event/SelectDate";
import BackButton from "@/components/ui/BackButton";
import {  auth } from "@/fireinit";
// import { auth } from "@/fireinit";

const SERVICE_FEE = 2;

export default {
  components: {
    SelectDate,
    BackButton
  },
  data() {
    return {
      isBuyLoading: false,
      userBasket: null
    };
  },

  computed: {
    ...mapGetters({
      displayedEvent: "user/displayedEvent"
    }),
    basketTotal() {
      if (!this.userBasket.tickets.length) return 0;
      let totalPrice = 0;
      let totalItems = 0;
      this.userBasket.tickets.forEach(item => {
        totalItems += item.numberOfTickets;
        totalPrice += item.ticketPrice * item.numberOfTickets;
      });
      const serviceFee = totalItems * SERVICE_FEE;
      totalPrice = totalPrice + serviceFee;
      return { totalPrice, totalItems, serviceFee };
    }
  },
  beforeRouteEnter(to, from, next) {
    if (!from.name) {
      next({ name: "event-view", params: { eventID: to.params.eventID } });
    } else {
      next();
    }
  },
  created() {
    console.log("BuyModal.vue is created");

    this.setUserBasket();
  },
  methods: {
    async buyTickets() {
      console.log("buy tickets", this.userBasket);
      if (this.basketTotal.totalPrice > 0) {
        this.isBuyLoading = true;
        await this.$store.dispatch("user/saveUserBasket", this.userBasket);
        this.isBuyLoading = false;

        if (auth.currentUser.isAnonymous) {
          // this.$store.commit("ui/SET_SIGNIN_MODAL", true);
          this.$store.dispatch("ui/toggleModal", {
            name: "SIGNIN_MODAL",
            state: true
          });
        } else {
          this.$store.commit("ui/SET_ROUTE_LOCK", false);
          this.$router.push({
            name: "payment-event-rules",
            query: { eventID: this.userBasket.eventInfo.eventID }
          });
        }
      } else {
        this.$buefy.toast.open({
          message: this.$t("ticket.selectTicketBeforeContinue"),
          position: "is-top"
        });
      }
    },

    setUserBasket() {
      // prepare tickets
      let tickets = JSON.parse(
        JSON.stringify(this.displayedEvent.data.eventTicketInfo.ticketTypes)
      );
      // give each ticket type a counter
      tickets.forEach(i => {
        i.numberOfTickets = 0;
      });

      this.userBasket = {
        userID: auth.currentUser.uid,
        eventInfo: {
          eventID: this.displayedEvent.id,
          eventName: this.displayedEvent.data.eventName,
          selectedShowtimeInd: 0,
          eventDateTime: {
            startTime: this.displayedEvent.data.eventShowtimes[0].startTime.toISOString(),
            endTime: this.displayedEvent.data.eventShowtimes[0].endTime.toISOString()
          },
          eventVenueName: this.displayedEvent.data.eventVenueName,
          eventVenueAddress: this.displayedEvent.details.eventVenueAddress,
          eventRules:
            this.displayedEvent.details.eventRules ||
            this.displayedEvent.details.eventConditions
        },
        tickets: tickets, //
        eventRulesIsAccepted: false,
        isCardInfoConfirmed: false,
        customerInfo: {
          isConfirmed: false,
          fullName: "",
          email: "",
          phoneNumber: ""
        }
      };
      console.log("set basket", this.userBasket);
    },
    setSelectedDateTime(val, key) {
      this.userBasket.eventInfo.eventDateTime.startTime = val.startTime.toISOString();
      this.userBasket.eventInfo.eventDateTime.endTime = val.endTime.toISOString();
      this.userBasket.eventInfo.selectedShowtimeInd = parseInt(key);
      this.userBasket.tickets.forEach(t => (t.numberOfTickets = 0));
    },
    decrementTicketNumber(ind) {
      if (this.userBasket.tickets[ind].numberOfTickets > 0) {
        this.userBasket.tickets[ind].numberOfTickets--;
      }
    },
    incrementTicketNumber(ind) {
      if (this.userBasket.tickets[ind].numberOfTickets < 6) {
        this.userBasket.tickets[ind].numberOfTickets++;
      }
    }
  }
};
</script>

<style lang="scss" scoped>

// .modal-bg {
//   background-color: $grey-dark;
// }

// .modal-view {
//   max-width: 92%;
//   margin: 16px auto 0 auto;
// }

.has-transition-slide-up {
  transform: translateY(100%);
  animation: slideUp 550ms 100ms ease-in-out forwards;
}

// .select-ticket-wrapper {
//   border: 1px solid $grey-lighter;
//   border-radius: 4px;
//   padding: 0.75rem;
// }
.columns .column {
  padding: 0 !important;
  margin: 0.75rem;
}

@keyframes slideUp {
  0% {
    transform: translateY(100%);
  }
  45% {
    transform: translateY(-2%);
  }
  100% {
    transform: translateY(0%);
  }
}
</style>